import { render, staticRenderFns } from "./AddPriceView.vue?vue&type=template&id=3cd6379c"
import script from "./AddPriceView.vue?vue&type=script&lang=js"
export * from "./AddPriceView.vue?vue&type=script&lang=js"
import style0 from "./AddPriceView.vue?vue&type=style&index=0&id=3cd6379c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports